import React from 'react';
import { TileBox } from './tile-box/TileBox';
import { t } from 'i18next';
import { AllBrandsStatsResponse } from '../../../../shared/models/projects/stats/AllBrandsStatsResponse';
import { getTextForVisibility } from '../../../../shared/utils/utils';

interface ProjectStatsTilesProps {
  projectGeneralData: AllBrandsStatsResponse | null;
  isLoading: boolean;
  // When provided (V2 / NEW_STATS), the Visibility tile shows this % value
  // (responses mentioning the brand / total responses). When omitted (V1),
  // the tile falls back to the qualitative text derived from brandScore.
  visibilityPercent?: number | null;
  // V2 / NEW_STATS: show Average Position instead of Median Position in the middle tile.
  useAveragePosition?: boolean;
}

const ProjectStatsTiles: React.FC<ProjectStatsTilesProps> = ({
  projectGeneralData,
  isLoading,
  visibilityPercent,
  useAveragePosition = false,
}) => {
  const hasData = projectGeneralData !== null && !isLoading;

  const usePercentVisibility = visibilityPercent !== undefined && visibilityPercent !== null;
  const visibilityText = projectGeneralData ? getTextForVisibility(projectGeneralData.brandScore) : '';
  return (
    <div className="tiles tiles--page">
      <TileBox
        hasData={hasData}
        label="brandScore"
        tooltipText="brandScoreTooltip"
        value={projectGeneralData ? Math.round(projectGeneralData.brandScore) : 0}
        trendValue={projectGeneralData?.trends.visibilityTrend || 0}
        suffix="%"
      />
      {useAveragePosition ? (
        <TileBox
          hasData={hasData}
          label="averagePosition"
          tooltipText="averagePositionTooltip"
          value={projectGeneralData ? projectGeneralData.position : 0}
          trendValue={projectGeneralData?.trends.positionTrend || 0}
        />
      ) : (
        <TileBox
          hasData={hasData}
          label="medianPosition"
          tooltipText="medianPositionTooltip"
          value={projectGeneralData ? projectGeneralData.medianPosition : 0}
          trendValue={projectGeneralData?.trends.medianTrend || 0}
        />
      )}
      {usePercentVisibility ? (
        <TileBox
          hasData={hasData}
          label="visibility"
          tooltipText="visibilityTooltip"
          value={t(getTextForVisibility(visibilityPercent as number))}
          subValue={`${Math.round(visibilityPercent as number)}%`}
          trendValue={0}
        />
      ) : (
        <TileBox
          hasData={hasData}
          label="visibility"
          tooltipText={visibilityText + 'Tooltip'}
          value={visibilityText ? t(visibilityText) : '-'}
          trendValue={0}
        />
      )}
    </div>
  );
};

export default ProjectStatsTiles;
